import React from 'react'
import classNames from 'classnames'
import Overlay from '../overlay'
import { getLayerClassName } from '../utils/get-layer-class-name'

export type SpinnerSize = 'custom' | 'xxs' | 'xs' | 'sm' | 'md' | 'lg'

type Props = {
  local?: boolean
  overlay?: boolean
  whiteOverlay?: boolean
  size?: SpinnerSize
  dustinSpinner?: boolean
}

export const Spinner = ({
  local = false,
  overlay = false,
  whiteOverlay = false,
  size = 'lg',
  dustinSpinner = false,
}: Props) => {
  return (
    <>
      <Overlay
        show={!local || overlay}
        local={local}
        whiteBackground={whiteOverlay}
        layer="spinner"
      />
      <div
        className={classNames('c-spinner', {
          [getLayerClassName('spinner')]: !local,
          'c-spinner--local': local,
          'c-spinner--xxs': size === 'xxs',
          'c-spinner--xs': size === 'xs',
          'c-spinner--sm': size === 'sm',
          'c-spinner--md': size === 'md',
        })}>
        {!dustinSpinner ? (
          <svg
            className="c-spinner__svg"
            width="150px"
            height="150px"
            viewBox="0 0 150 150"
            xmlns="http://www.w3.org/2000/svg">
            <circle
              className="c-spinner__path"
              fill="none"
              strokeWidth="16"
              strokeLinecap="square"
              cx="75"
              cy="75"
              r="67"></circle>
          </svg>
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 208.21 190.98"
              className="c-spinner__new">
              <g strokeWidth="2" stroke="none" fill="none" fillRule="evenodd">
                <path
                  stroke="#161412"
                  className="spin-left"
                  fill="#161412"
                  d="M171.79,23.87A47.75,47.75,0,0,0,130.44,0H66.12A31.82,31.82,0,0,0,38.56,15.92L6.4,71.62a47.73,47.73,0,0,0,0,47.74l32.16,55.71A31.83,31.83,0,0,0,66.12,191h64.32a47.75,47.75,0,0,0,41.35-23.87L204,111.41a31.83,31.83,0,0,0,0-31.84Zm-124,145.88V21.22L66.13"></path>
              </g>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 208.21 190.98"
              className="c-spinner__new">
              <g transform="translate(47,0)" id="Layer_1-2" data-name="Layer 1">
                <path
                  className="spin-right"
                  fill="#ffffff"
                  d="M147,74.27V95.49L18.39,169.75,0,159.14V10.61L18.38,0Z"
                />
              </g>
            </svg>
          </>
        )}
      </div>
    </>
  )
}

export default Spinner
